import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

import classes from "./TableDataComponent.module.css";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { Calendar } from "primereact/calendar";

const TableDataComponent = (props) => {
  const { data, setData, editable, onSave, onDelete, fake } = props;

  const onRowEditComplete = async (e) => {
    if (onSave) {
      let { newData, index } = e;
      onSave({ data: newData, index });
    }
    // if (editable) {
    //   let { newData, index } = e;
    //   const copyData = [...data];
    //   copyData[index] = newData;
    //   if (onSave) {
    //     const saveSuccess = await onSave(newData);
    //     if (saveSuccess) {
    //       setData(copyData);
    //     }
    //   }
    // }
  };

  const tanggalMasukTemplate = (row) => {
    const tanggal = row.masuk_tanggal;
    if (tanggal) {
      const newTanggal = new Date(tanggal);
      return format(newTanggal, "dd/MM/yyyy HH:mm");
    }
    return "";
  };

  const tanggalKeluarTemplate = (row) => {
    const tanggal = row.keluar_tanggal;
    if (tanggal) {
      const newTanggal = new Date(tanggal);
      return format(newTanggal, "dd/MM/yyyy HH:mm");
    }
    return "";
  };

  const jumlahBodyTemplate = (row) => {
    if (fake) {
      return row.jumlah_edited.toLocaleString("id-ID");
    } else {
      return row.jumlah.toLocaleString("id-ID");
    }
  };

  const jumlahEditedBodyTemplate = (row) => {
    return row.jumlah_edited.toLocaleString("id-ID");
  };

  const deleteTemplate = (rowData) => {
    const accept = () => {
      if (onDelete) {
        onDelete(rowData);
      }
    };

    const reject = () => {};

    return (
      <Button
        icon="pi pi-trash"
        className="max-w-[2rem] max-h-[2rem] text-red-500"
        text
        onClick={(e) => {
          confirmPopup({
            target: e.currentTarget,
            message: "Hapus data?",
            icon: "pi pi-info-circle",
            defaultFocus: "reject",
            acceptClassName: "p-button-danger",
            accept,
            reject,
          });
        }}
      />
    );
  };

  const numberEditor = (options) => {
    return (
      <InputNumber
        className={`${classes.wrapperInputNumber} w-[7rem]`}
        value={options.value}
        onChange={(e) => options.editorCallback(e.value)}
        minFractionDigits={0}
        maxFractionDigits={2}
        locale="id-ID"
      />
    );
  };

  const textEditor = (options) => {
    return (
      <InputText
        className={`w-[10rem]`}
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
      />
    );
  };

  const dateEditor = (options) => {
    const txtValue = options.value;
    const dateValue =
      txtValue && txtValue.length > 0 ? new Date(txtValue) : new Date();
    return (
      <Calendar
        className="w-[12rem]"
        showTime
        value={dateValue}
        onChange={(e) =>
          options.editorCallback(format(e.value, "yyyy-MM-dd HH:mm:ss"))
        }
      />
    );
  };

  return (
    <>
      <ConfirmPopup />
      <DataTable
        className="w-full"
        dataKey="id"
        showGridlines
        paginator
        rows={50}
        rowsPerPageOptions={[5, 10, 20, 50, 100, 200, 400, 600, 1000]}
        value={data}
        editMode="row"
        onRowEditComplete={onRowEditComplete}
      >
        <Column field="no" header="#"></Column>
        <Column field="jenis" header="Jenis" editor={textEditor}></Column>
        <Column
          field="masuk_tanggal"
          body={tanggalMasukTemplate}
          header="Tgl Masuk"
          editor={dateEditor}
        ></Column>
        <Column field="masuk_op" header="Op Masuk" editor={textEditor}></Column>
        <Column
          field="keluar_tanggal"
          body={tanggalKeluarTemplate}
          header="Tgl Keluar"
          editor={dateEditor}
        />
        <Column field="keluar_kasir" header="Kasir" editor={textEditor} />
        <Column field="nomor_plat" header="Plat" editor={textEditor} />
        <Column field="lama" header="Lama" editor={textEditor} />
        {/* <Column field="pembayaran" header="BYR" editor={textEditor} />
        <Column field="overnight" header="OV" editor={textEditor} />
        <Column field="tiket_hilang" header="Hilang" editor={textEditor} />
        <Column field="nomor_manual" header="Manual" editor={textEditor} />
        <Column field="nomor_voucher" header="Voucher" editor={textEditor} /> */}
        <Column
          className="text-right"
          alignHeader={"right"}
          editor={numberEditor}
          field="jumlah"
          body={jumlahBodyTemplate}
          header="Jlh"
        />
        {editable && (
          <Column
            field="jumlah_edited"
            header="Jlh Edited"
            editor={numberEditor}
            body={jumlahEditedBodyTemplate}
            bodyStyle={{ textAlign: "right" }}
            alignHeader={"right"}
          />
        )}
        {editable && <Column body={deleteTemplate} field="" />}

        {editable && (
          <Column
            rowEditor={true}
            headerStyle={{
              width: "7rem",
              minWidth: "7rem",
            }}
            bodyStyle={{ textAlign: "left" }}
          ></Column>
        )}
      </DataTable>
    </>
  );
};

export default TableDataComponent;
